module.exports = __webpack_public_path__ + "img/student-hat.7832d201.svg";